// extracted by mini-css-extract-plugin
export default {"content":"xycbr","button":"Imocn","mobile":"RDMqP"};